import { useTranslation } from "react-i18next"
import { StatusBadgeHelp } from "@dehub/theme"
import { DotPill, Tone } from "../../delivery/atoms"

const TONES: Record<string, Tone> = {
  DRAFT: "grey",
  INITIATED: "amber",
  SENDER_VERIFIED: "amber",
  RECEIVER_VERIFIED: "blue",
  COMPLETED: "green",
  CANCELLED: "grey",
}

interface Props {
  status: string | null | undefined
  /** Kept for call-site compatibility; the pill has one size. */
  size?: unknown
}

/** Handover status as a dot pill (canvas Ord_HandoverDetail «Илгээгч баталсан»). */
export function CustodyStatusBadge({ status }: Props) {
  const { t } = useTranslation("delivery")
  if (!status) return <>-</>
  const name = t(`custody.status.${status}`, { defaultValue: "-" })
  // @dehub/help: hover popover with the status guide (R5); plain pill without content (R10).
  return (
    <StatusBadgeHelp helpNs="order.handover-status" code={status} name={name}>
      <DotPill tone={TONES[status] ?? "grey"}>{name}</DotPill>
    </StatusBadgeHelp>
  )
}
